import { render } from "./SingleComment.vue?vue&type=template&id=3f469b41"
import script from "./SingleComment.vue?vue&type=script&lang=js"
export * from "./SingleComment.vue?vue&type=script&lang=js"
script.render = render

export default script